import { Button, Modal, Stack } from '@servicetitan/design-system';
import { FC } from 'react';
import { PortalModalNew, PortalModalNewProps } from '../modals/modals-new';
import * as Styles from './pdf-modal.module.less';
import { PdfViewer } from './pdf-viewer';

export interface PdfModalProps extends PortalModalNewProps {
    file: string;
    open: boolean;
    onClose: () => void;
    title?: string;
}

export const PdfModal: FC<PdfModalProps> = ({
    file,
    onClose,
    scrollable = false,
    size = Modal.Sizes.L,
    ...rest
}) => {
    return (
        <PortalModalNew
            size={size ?? Modal.Sizes.L}
            contentClassName={Styles.pdfModalContent}
            className={Styles.pdfModal}
            onClose={onClose}
            footer={
                <Stack>
                    <Button onClick={onClose}>Close</Button>
                </Stack>
            }
            scrollable={scrollable}
            {...rest}
        >
            <PdfViewer
                className="h-100"
                scrollContainerClassName={Styles.pdfModalViewer}
                file={file}
            />
        </PortalModalNew>
    );
};
